import { render, staticRenderFns } from "./media-notas-por-escola.vue?vue&type=template&id=e93384c4&scoped=true&"
import script from "./media-notas-por-escola.vue?vue&type=script&lang=js&"
export * from "./media-notas-por-escola.vue?vue&type=script&lang=js&"
import style0 from "./media-notas-por-escola.vue?vue&type=style&index=0&id=e93384c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93384c4",
  null
  
)

export default component.exports